import { useTranslation } from 'react-i18next'
import {
  invalidateNews,
  useGetNewsArticle,
  useUpdateCustomerNews,
} from 'src/api/news'
import { useGetLocalityGroups } from 'src/api/locality-groups'
import { useGetCustomerLocalities } from 'src/api/localities'
import { useGetServiceStations } from 'src/api/service-station'
import { useGetAllStorageWithCustomers } from 'src/api/storage'
import { APIResultCount } from 'src/constant'
import { CenteredSpinner } from 'src/components/Spinner'
import { IUpdateNewsArticle } from 'src/generated-types/news'
import { NewsArticleForm, NewsArticleFormValues } from 'src/forms/NewsArticleForm'
import { ShowDialogProps } from 'src/show-dialog'

interface UpdateNewsArticleDialogProps extends ShowDialogProps {
  customerId: number
  articleId: number
  hasLocalities?: boolean
  hasServiceStations?: boolean
  hasStorages?: boolean
}

const UpdateNewsArticleDialog: React.FC<UpdateNewsArticleDialogProps> = ({
  pop,
  customerId,
  articleId,
  hasLocalities,
  hasServiceStations,
  hasStorages,
}) => {
  const { t: translate } = useTranslation(['common'])
  const { data: article, isLoading: isLoadingArticle } = useGetNewsArticle(customerId, articleId)
  const updateMutation = useUpdateCustomerNews(customerId, articleId)
  const { data: localityGroups } = useGetLocalityGroups(customerId, 0, APIResultCount.Max)
  const { data: localities } = useGetCustomerLocalities({ clientId: customerId })
  const { data: serviceStations } = useGetServiceStations(customerId)
  const { data: storages } = useGetAllStorageWithCustomers(customerId)

  const handleSubmit = async (values: NewsArticleFormValues) => {
    const payload: IUpdateNewsArticle = { ...values, id: articleId }
    await updateMutation.mutateAsync(payload)
    invalidateNews.all(customerId)
    invalidateNews.getCustomerNewsArticle(customerId, articleId)
    pop(true)
  }

  if (isLoadingArticle) return <CenteredSpinner />

  return (
    <NewsArticleForm
      title={translate('update-news-article', { ns: 'news' })}
      onSubmit={handleSubmit}
      onCancel={() => pop()}
      initialValues={article}
      localityGroups={localityGroups?.items ?? []}
      localities={(localities as any[]) ?? []}
      serviceStations={(serviceStations as any[]) ?? []}
      storages={(storages as any[]) ?? []}
      isLoading={updateMutation.isLoading}
      disableGlobalTarget
      hasLocalities={hasLocalities}
      hasServiceStations={hasServiceStations}
      hasStorages={hasStorages}
    />
  )
}

export default UpdateNewsArticleDialog
